var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

/**
 * CryptoKeyPair dictionary
 */
var CryptoKeyPair =
/*#__PURE__*/
function () {
  "use strict";

  function CryptoKeyPair(_ref) {
    var publicKey = _ref.publicKey,
        privateKey = _ref.privateKey;

    _classCallCheck(this, CryptoKeyPair);

    this.publicKey = publicKey;
    this.privateKey = privateKey;
  }

  return CryptoKeyPair;
}();
/**
 * Export
 */


module.exports = CryptoKeyPair;